/* eslint-disable camelcase */
export enum FormMode {
  // Значение по-умолчанию:
  Default = 'Default',
  // Подтверждение номера телефона с помощью кода из СМС и обратный отсчёт:
  ConfirmPhoneNumber_Timer = 'ConfirmPhoneNumber_Timer',
  // Подтверждение номера телефона с помощью кода из СМС и кнопка "Отправить СМС":
  ConfirmPhoneNumber_SmsButton = 'ConfirmPhoneNumber_SmsButton',
  // Забыли пароль, "Письмо отправлено, проверьте почту":
  PasswordIsForgottenEmail = 'PasswordIsForgottenEmail',
  // Забыли пароль, "Введите последние 4 цифры входящего номера" и обратный отсчёт:
  PasswordIsForgottenCallCode_Timer = 'PasswordIsForgottenCallCode_Timer',
  // Забыли пароль, "Введите последние 4 цифры входящего номера" и кнопки "Позвонить повторно" и "Отправить СМС":
  PasswordIsForgottenCallCode_SmsOrCallButtons = 'PasswordIsForgottenCallCode_SmsOrCallButtons',
  // Забыли пароль, поле "Код из смс" и обратный отсчёт (RU):
  PasswordIsForgottenSmsCodeRuLocale_Timer = 'PasswordIsForgottenSmsCodeRuLocale_Timer',
  // Забыли пароль, поле "Код из смс" и обратный отсчёт (остальные локали):
  PasswordIsForgottenSmsCodeOtherLocales_Timer = 'PasswordIsForgottenSmsCodeOtherLocales_Timer',
  // Забыли пароль, поле "Код из смс" и кнопки "Позвонить повторно" и "Отправить СМС":
  PasswordIsForgottenSmsCode_SmsOrCallButtons = 'PasswordIsForgottenSmsCode_SmsOrCallButtons',
  // Забыли пароль, поле "Код из смс" и кнопка "Отправить СМС":
  PasswordIsForgottenSmsCode_SmsButton = 'PasswordIsForgottenSmsCode_SmsButton',
  // Письмо отправлено, проверьте почту:
  EmailHasSended = 'EmailHasSended',
  // Пароль устарел
  PasswordIsOld = 'PasswordIsOld',
}

export enum AutoComplete {
  On = 'on',
  Off = 'off',
}

export enum FieldName {
  Login = 'login',
  Password = 'password',
  CallCode = 'callCode',
  SmsCode = 'smsCode',
}
export const PHONE_CALL_CODE_MIN_LENGTH = 4
export const BUTTON_NODE = 'button-node'
export const GET_CODE_AGAIN_TEXT = 'app.formComponents.form.sendCode.getCodeAgain'
export const PASSWORD_IS_REQUIRED_ERROR = 'app.logon.password.errors.valueIsRequired.message'
export const INCORRECT_EMAIL_OR_PHONE_ERROR = 'app.logon.login.errors.incorrectEmailOrPhone.message'
export const CONFIRM_EMAIL_TEXT = 'app.logon.login.confirmEmail'
export const LOGIN_LABEL = 'app.logon.login.label'
export const PHONE_CODE_LABEL = 'app.logon.phoneCode.enterCallCodeText'
export const SMS_CODE_LABEL = 'app.logon.phoneCode.label'
export const PASSWORD_LABEL = 'app.logon.password.label'
export const CREATE_ACCOUNT_BUTTON_TEXT = 'app.logon.registration.createAccount'
export const LOGIN_WITH_TEXT = 'app.logon.login.loginWith'
export const RESEND_EMAIL = 'app.logon.login.resend'
export const LOGIN_CALL_TEXT = 'app.logon.login.callText'
export const AUTHORIZATION_BUTTON_TEXT = 'app.logon.authorization.buttonText'
export const UPDATE_PASSWORD_TEXT = 'app.logon.authorization.updatePassword'
export const AUTHORIZATION_CONTINUE = 'app.logon.authorization.continue'
export const GENERATE_SMS_CODE_TIME_ERROR = 'app.errors.A previous sms code sent less than a minute ago'
export const TRY_AFTER_ONE_HOUR = 'app.errors.Try after 1 hour'
export const INVALID_CALL_CODE_ERROR = 'app.errors.Invalid verification call code entered'
export const EMAIL_OR_PHONE_IS_REQUIRED_ERROR = 'app.logon.login.errors.valueIsRequired.message'
export const WRONG_PASSWORD_ERROR = 'app.logon.password.errors.wrongPassword'
export const WRONG_PASSWORD_EMAIL_ERROR = 'app.logon.password.errors.wrongPasswordForEmail'
export const OLD_PASSWORD_ERROR = 'app.logon.password.errors.oldPassword'
export const SAME_PASSWORD_ERROR = 'app.logon.password.errors.samePassword'
export const PASSWORD_CHANGE_OLD_PAGE_ERROR = 'app.logon.password.errors.oldPage'
export const INCORRECT_SMS_CODE_ERROR = 'app.logon.phoneCode.errors.incorrectValue.message'
export const FORGOT_PASSWORD_TEXT = 'app.logon.password.reset.forgotPassword'
export const PASSWORD_RESET_SUCCESS_TEXT = 'app.logon.password.reset.successText'
export const TOO_MANY_REQUESTS = 'app.errors.Try after 30 seconds'
export const SERVER_ERROR = 'app.logon.login.errors.serverError.message'
export const BAD_REQUEST = 400
export const UNAUTHORIZED = 401
export const LOGON_EVENT_GROUP = 'HeadForm'
export const INCORRECT_PHONE_CODE_ERROR = 'app.logon.phoneCode.errors.incorrectValue.message'
